// extracted by mini-css-extract-plugin
export default {"container":"otp_container__HvfOC","otp-input":"otp_otp-input__cLz9p"};